import React from "react";

type MarkIconProps = {
  isPositive: boolean;
};
export default function MarkIcon({ isPositive }: MarkIconProps) {
  return isPositive ? (
    <span className="mark-true">
      <i className="fa-regular fa-circle-check text-green-100"></i>
    </span>
  ) : (
    <span className="mark-false">
      <i className="fa-regular fa-circle-xmark text-danger"></i>
    </span>
  );
}
